import "../styles.css";
import React, { memo, useEffect, useState } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
  clearData,
  createInitialOrder,
  fetchReferralCode,
  getJumioVerificationUrl,
  setData,
  changeFormField,
  getJumioSessionToken,
  createEnterpriseWorkFlow,
  fetchMyInfoDetails,
  getSingPassPersonInfo
} from "ducks/actions";
import {
  makeSelectIsFetchingData,
  makeSelectOrderParams,
  makeSelectPayMonthlyItems,
  makeSelectPayTodayItems,
  makeSelectDeliveryDetailsItems,
  makeSelectReferralCode,
  makeSelectPaymentRequest,
  makeSelectOrderSummaryForm,
  makeSelectOrderSummaryFormInitialValues,
  makeSelectOrderSummaryPayload,
  makeSelectESigned,
  makeSelectPaymentModes,
  makeSelectFormattedSelectedNumber,
  makeSelectAddons,
  makeSelectPlanDetails,
  makeSelectDefaultPromoCodeOffers,
  makeSelectSessionToken,
  makeSelectIosDevice,
  makeSelectJumioRedirectUrl,
  makeSelectSadOrderParams,
  makeSelectOrder,
  makeSelectJumioData,
  makeSelectJumioSessionToken,
  makeSelectValidateIccId,
  makeSelectEKYCMessageData,
  makeSelectMyInfo,
  makeSelectMyInfoIsUsed,
  makeSelectMyInfoDetails,
  makeSelectSignPass,
  makeSelectJumioIsUsed,
  makeSelectGuestOrder,
  makeSelectIsWalletPromoCode,
  makeSelectEkycValidation,
  makeSelectMyInfoIsInvalid,
  makeSelectAppSettings
} from "ducks/selectors";
import SmartRender from "containers/SmartRender";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import forEach from "lodash/forEach";
import {
  urlParam,
  gotoUrl,
  setMyInfoFieldToClear,
  buildJumioParams,
  isUnifiedEKYCFlow,
  getChannelFromUrl,
  buildStoredJumioAuthHeaders
} from "utils/helpers";
import {
  SELF_ACT_DEL,
  REFERER_TYPE,
  forms,
  paths,
  JUMIO_PARAMS,
  VERIFY_IDENTITY_CHANNEL,
  ENTERPRISE,
  MYINFO_PARAMS
} from "utils/constants";
import Spinner, { styles } from "components/Spinner";
import {
  getDeviceId,
  setSessionToken,
  setJumioToken,
  getRequestId
} from "utils/localStorage";
import { makeSelectSimCountNewAndTransfer, makeSelectIsSimTypeEsim, makeSelectAuditLogData, makeSelectIsTermsAndConditionAccept, makeSelectEnableSimCountNextButton } from "ducks/selectors/planService";
import ErrorModal from "components/EnterpriseAutomated/ErrorModal/index";

const EkycHOC = Component =>
  function Comp(props) {
    const {
      orderParams,
      referralCode,
      isFetchingJumio,
      isFetchingJumioSessionToken,
      clearAllMyInfoData,
      jumioData,
      jumioIsUsed,
      jumioVerificationCall,
      validateIccid,
      token,
      nextPage, // goes to jumio url
      myInfoIsUsed,
      guestOrder,
      jumioSessionToken,
      getJumioVerificationUrl: callGetJumioVerificationUrl,
      getJumioSessionToken: callGetJumioSessionToken,
      createInitialOrder: callCreateInitialOrder,
      getSingPassPersonInfo: callSignPassInfoDetails,
      createEnterpriseWorkFlow: callCreateEnterpriseWorkFlow,
      myInfoIsInvalid,
      setMyInfoIsUsed,
      simCounts,
      isSimTypeEsim,
      clearMyInfoUrlParam,
      planDetails,
      addons
    } = props;
    const [errorModal, setErrorModal] = useState({
      show: false,
      header: "",
      message: "",
      navigate:""
    });
    const closeErrorModal = () => {
      setErrorModal({
        show: false,
        header: "",
        message: "",
        navigate:""
      });
    };
    const [lastPromoCode, setLastPromoCode] = useState(
      get(referralCode, "value")
    );
    const tokenFromURL = urlParam("token");
    const [refererType, setRefererType] = useState(null);
    const [loading, setLoading] = useState(true);
    const isJumioFulFilementAPI = get(props, "appSettings.enable_jumio_fulfillment_flow", false);
    console.log("PLAN DETAILS", planDetails)
    const [
      hasRequestedJumioSessionToken,
      setHasRequestedJumioSessionToken
    ] = useState(false);

    useEffect(() => {
      if (urlParam("reset")) {
        gotoUrl("/enterprise/automated-onboarding?reset=true")
      }
      if(simCounts?.totalSimCount === 0){
        gotoUrl("/enterprise/automated-onboarding?reset=true")
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])


    /**
     * Workflow API 
     * Update the Sim Count and Sim Type and Promocode details
     */
    useEffect(() => {
      const selectedAddons = addons.filter(val => val.selected === true);
      if(simCounts.newSimCount || simCounts.transferSimCount){
        const headersValue = buildStoredJumioAuthHeaders();
        const payload = {
          workflow: "create_order",
          request_id: getRequestId(),
          status: "success",
          metadata: {
            sim_type: isSimTypeEsim ? "esim" : "psim",
            portin_count: get(simCounts, "transferSimCount", 0),
            new_number_count: get(simCounts, "newSimCount", 0),
            referralDetails: referralCode,
            plan_details: {
              plan_name: planDetails?.name || "",
              plan_price: planDetails?.basicPrice || "",
              plan_data: planDetails?.data || "",
              plan_minutes: planDetails?.minutes || "",
              plan_sms: planDetails?.sms || "",
              subscription_plan_fee: planDetails?.activation_charge || "",
              plus_addons_details: planDetails?.default_products || [],
              selected_addons: selectedAddons || []
            }
          }
        };
        callCreateEnterpriseWorkFlow(headersValue, payload, () => {});
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [simCounts.newSimCount, simCounts.transferSimCount])
 
    useEffect(() => {
      const code = urlParam(MYINFO_PARAMS.CODE);
      const state = urlParam(MYINFO_PARAMS.STATE) === MYINFO_PARAMS.STATE_200;
      const stateParam = urlParam(MYINFO_PARAMS.STATE);
      const error = urlParam("error")
      if (code && !state) {
        clearMyInfoUrlParam();
        setMyInfoIsUsed(true);
        const headersValue = buildStoredJumioAuthHeaders();
        const params = {
          code,
          state: stateParam,
          session_id: window.sessionStorage.getItem("signPassSession")
        };

        callSignPassInfoDetails(headersValue, params, () => {});
      }
      if(error){
        setErrorModal({
          show: true,
          header: "We’re unable to proceed with your order",
          message: "The identity did not pass our verification checks.",
          navigate: "https://www.circles.life/sg/business-solutions"
        });
        setMyInfoIsUsed(false);
        clearMyInfoUrlParam()
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    useEffect(() => {
      if (
        hasRequestedJumioSessionToken ||
        isFetchingJumioSessionToken ||
        jumioSessionToken
      ) {
        return;
      }

      setHasRequestedJumioSessionToken(true);

      callGetJumioSessionToken(
        { "Content-Type": "application/json" },
        {
          subject: getDeviceId()
        },
        result => {
          const jumioSessionToken =
            get(result, "token") ||
            (typeof result === "string" ? result : "");

          if (jumioSessionToken) {
            setJumioToken(jumioSessionToken);
          }
        }

      );
    }, [
      callGetJumioSessionToken,
      hasRequestedJumioSessionToken,
      isFetchingJumioSessionToken,
      jumioSessionToken
    ]);

    useEffect(() => {
      if (
        getChannelFromUrl() === VERIFY_IDENTITY_CHANNEL &&
        isEmpty(guestOrder) &&
        window.MANDATE_GUEST_ORDER_FOR_REDO_EKYC
      ) {
        setLoading(true);
        gotoUrl(paths.MANAGE_ORDER, true, { reset: true });
      } else {
        setLoading(false);
      }
    }, [guestOrder]);

    useEffect(() => {
      setRefererType(
        isEmpty(tokenFromURL) ? REFERER_TYPE.DEFAULT : REFERER_TYPE.DIRECT_LINK
      );
      // console.log("AAA SessionToken :1:", tokenFromURL)
      tokenFromURL && setSessionToken(tokenFromURL);
    }, [tokenFromURL]);

    useEffect(() => {
      if (refererType === REFERER_TYPE.DIRECT_LINK && isEmpty(nextPage)) {
        jumioVerificationCall(tokenFromURL, isJumioFulFilementAPI);
      }
    }, [jumioVerificationCall, refererType, tokenFromURL, nextPage, isJumioFulFilementAPI]);

    useEffect(() => {
      if (!isFetchingJumio && refererType === REFERER_TYPE.DIRECT_LINK) {
        let redirectToManageOrderConditionMet =
          !isEmpty(jumioData) &&
          isEmpty(get(jumioData, JUMIO_PARAMS.TRANSACTION_REF, ""));

        if (redirectToManageOrderConditionMet) {
          props.history.push(paths.MANAGE_ORDER);
        }
      }
    }, [refererType, isFetchingJumio, jumioData, props.history]);

    useEffect(
      () => {
        // if jumio redirect url is available dont need to call this
        if (refererType === REFERER_TYPE.DEFAULT && isEmpty(nextPage)) {
          if (isFetchingJumioSessionToken || !jumioSessionToken) return;
          let callJumio = null;
          const isSadFlow = get(validateIccid, "channel") === SELF_ACT_DEL;
          const isEnterpriseFlow = getChannelFromUrl() === ENTERPRISE;
          if (isJumioFulFilementAPI) {

            callJumio = (sessionToken, nextPath) => {
              window.sessionStorage.setItem("sessionToken", sessionToken)
            };
          } else {
            callJumio = (sessionToken, nextPath) => {
              window.sessionStorage.setItem("sessionToken", sessionToken)
              if (sessionToken) {
                const params = buildJumioParams(
                  sessionToken,
                  nextPath,
                  paths.EKYC,
                  isJumioFulFilementAPI
                );
                callGetJumioVerificationUrl(params);
              }
            };
          }


          const toPath = isUnifiedEKYCFlow()
            ? paths.PERSONAL_DETAILS
            : paths.ORDER_SUMMARY;

          if (isSadFlow || isEnterpriseFlow) {
            if (!myInfoIsUsed && !jumioIsUsed) callJumio(token, toPath);
          } else {
            // console.log("AAAA orderParams :::", !isEmpty(orderParams), !token);
            if (!isEmpty(orderParams) && !token) {
              callCreateInitialOrder(orderParams, result => {
                const tokenFromRes = get(result, "session_token");
                callJumio(tokenFromRes, toPath);
              });
            } else {
              callJumio(token, toPath);
            }
          }
        }
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [
        refererType,
        myInfoIsUsed,
        jumioIsUsed,
        jumioSessionToken,
        isFetchingJumioSessionToken,
        // hasRequestedJumioVerificationUrl
      ]
    );

    useEffect(
      () => {
        const promoCode = get(referralCode, "value");
        if (promoCode !== lastPromoCode) {
          setLastPromoCode(promoCode);
        }
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [referralCode, lastPromoCode, setLastPromoCode]
    );

    useEffect(() => {
      if (myInfoIsInvalid && isUnifiedEKYCFlow()) {
        clearAllMyInfoData();
      }
    }, [clearAllMyInfoData, myInfoIsInvalid]);

    return loading ? (
      <Spinner size={200} sx={styles.fullPage} />
    ) : (
       <>
        {errorModal.show && (
          <ErrorModal
            showModal={errorModal.show}
            errorHeader={errorModal.header}
            errorMessage={errorModal.message}
            onClose={closeErrorModal}
            navigate={errorModal.navigate}
          />
        )}
        <Component {...props} />
      </>
    );
  };

const mapStateToProps = createStructuredSelector({
  formValues: makeSelectOrderSummaryForm(),
  payload: makeSelectOrderSummaryPayload(),
  order: makeSelectOrder(),
  paymentRequest: makeSelectPaymentRequest(),
  orderParams: makeSelectOrderParams(),
  sadOrderParams: makeSelectSadOrderParams(),
  isCreatingOrder: makeSelectIsFetchingData("order"),
  isIosDevice: makeSelectIosDevice(),
  nextPage: makeSelectJumioRedirectUrl(),
  isFetchingPaymentRequest: makeSelectIsFetchingData("paymentRequest"),
  payMonthlyItems: makeSelectPayMonthlyItems(),
  payTodayItems: makeSelectPayTodayItems("OrderSummary"),
  deliveryDetailsItems: makeSelectDeliveryDetailsItems(),
  referralCode: makeSelectReferralCode(),
  eSigned: makeSelectESigned(),
  paymentModes: makeSelectPaymentModes(),
  initialValues: makeSelectOrderSummaryFormInitialValues(),
  selectedNumber: makeSelectFormattedSelectedNumber(),
  addons: makeSelectAddons(),
  planDetails: makeSelectPlanDetails(),
  token: makeSelectSessionToken(),
  defaultPromoCodeOffers: makeSelectDefaultPromoCodeOffers(),
  isFetchingJumio: makeSelectIsFetchingData("jumio"),
  isFetchingJumioSessionToken: makeSelectIsFetchingData("jumioSessionToken"),
  validateIccid: makeSelectValidateIccId(),
  messageData: makeSelectEKYCMessageData(),
  myInfo: makeSelectMyInfo(),
  myInfoIsUsed: makeSelectMyInfoIsUsed(),
  myInfoDetails: makeSelectMyInfoDetails(),
  signPass: makeSelectSignPass(),
  jumioIsUsed: makeSelectJumioIsUsed(),
  jumioData: makeSelectJumioData(),
  jumioSessionToken: makeSelectJumioSessionToken(),
  jumioRedirectUrl: makeSelectJumioRedirectUrl(),
  guestOrder: makeSelectGuestOrder(),
  isWalletPromoCode: makeSelectIsWalletPromoCode(),
  ekycValidation: makeSelectEkycValidation(),
  myInfoIsInvalid: makeSelectMyInfoIsInvalid(),
  appSettings: makeSelectAppSettings(),
  simCounts: makeSelectSimCountNewAndTransfer(),
  isSimTypeEsim: makeSelectIsSimTypeEsim(),
  enableSimCountNextBtn: makeSelectEnableSimCountNextButton(),
  auditLogData: makeSelectAuditLogData(),
  isTermsAndConditionAccept: makeSelectIsTermsAndConditionAccept()
});

export function mapDispatchToProps(dispatch) {
  return {
    createEnterpriseWorkFlow: (headersValue, params) => {
      dispatch(createEnterpriseWorkFlow(headersValue, params));
    },
    fetchMyInfoDetails: (params, callback) => {
      dispatch(fetchMyInfoDetails(params, callback));
    },
    getJumioVerificationUrl: (headersValue, params, callback) => {
      dispatch(getJumioVerificationUrl(headersValue, params, callback));
    },
    getSingPassPersonInfo: (headers, params, callback) => {
      // console.log("AAAAAA 22323", headers)
      dispatch(getSingPassPersonInfo(headers, params, callback));
    },
    jumioVerificationCall: (tokenFromURL, isJumioFulFilementAPI) => {
      if (!tokenFromURL) return;
      if (!isJumioFulFilementAPI) {
        if (tokenFromURL) {
          const params = buildJumioParams(
            tokenFromURL,
            paths.PERSONAL_DETAILS,
            paths.EKYC,
            isJumioFulFilementAPI
          );
          dispatch(getJumioVerificationUrl(params));
        }
      } else {
        window.sessionStorage.setItem("sessionToken", tokenFromURL);
        // dispatch(getJumioSessionToken(
        //   { "Content-Type": "application/json" },
        //   {
        //     subject: getDeviceId()
        //   },
        //   result => {
        //     const jumioSessionToken =
        //       get(result, "token") ||
        //       (typeof result === "string" ? result : "");

        //     if (jumioSessionToken) {
        //       setJumioToken(jumioSessionToken);
        //       const headersValue = {
        //         Authorization: `Bearer ${jumioSessionToken}`
        //       };
        //       const params = buildJumioParams(
        //         tokenFromURL,
        //         paths.PERSONAL_DETAILS,
        //         paths.EKYC,
        //         isJumioFulFilementAPI
        //       );
        //       dispatch(getJumioVerificationFulfillmentUrl(headersValue, params));
        //     }

        //   }))
      }
    },
    createInitialOrder: (orderParams, callback) => {
      dispatch(createInitialOrder(orderParams, callback));
    },
    getJumioSessionToken: (headers, params, callback) => {
      dispatch(getJumioSessionToken(headers, params, callback));
    },
    // getSignPassLinkUrl: (headersValue, params, callback) => {
    //   dispatch(getSignPassLinkUrl(headersValue, params, callback));
    // },
    validateReferralCode: (code, planName) => {
      dispatch(fetchReferralCode({ referral_code: code, plan_name: planName }));
    },
    clearMyInfoDomain: () => {
      dispatch(clearData("myInfoDetails"));
    },
    setMyInfoIsUsed: isUsed => {
      dispatch(
        setData({
          key: "myInfo",
          data: { isUsed }
        })
      );
      dispatch(
        changeFormField({
          form: forms.PERSONAL_DETAILS_FORM,
          field: "myInfoIsUsed",
          value: isUsed
        })
      );
    },
    changeField: (field, value) => {
      dispatch(
        changeFormField({
          form: forms.PERSONAL_DETAILS_FORM,
          field: field,
          value: value
        })
      );
    },
    clearAllMyInfoData: () => {
      dispatch(clearData("myInfoDetails"));
      dispatch(clearData("myInfo"));
    },
    resetReferralCode: () =>
      dispatch(clearData(["referralCode", "selectedAddons"]))
  };
}

export const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    clearMyInfoUrlParam: () => {
      gotoUrl(window.location.pathname, true, {
        code: null,
        state: null,
        iss: null,
        error_description: null,
        error: null,
      });
    },
    clearMyInfoFormFields: (fieldNameToClear = []) => {
      const changeField = dispatchProps.changeField;
      const fieldMap = setMyInfoFieldToClear(fieldNameToClear);
      forEach(fieldMap, fieldName => {
        changeField(fieldName, null);
      });
    }
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps, mergeProps);
export default compose(withConnect, memo)(EkycHOC(SmartRender));
